import { FormTracker } from '@rs/form-tracking-sdk';
import { TaxServiceOptions } from '../../../modules/ReferralForm/enums';
import { ReferralResponse } from '../../../modules/ReferralForm/api/createReferral';
import { trackFormSubmitted } from '../../../shared/analytics';
import {
  formTracker,
  navigateToResultsPage,
  waitForTracking
} from '../../../shared/utils';
import { getAnsweredString, MatcherAnswers } from '../flow/types';
import { getNameParts } from '../flow/getNameParts';
import { mapServicesToInterests } from '../flow/mapServicesToInterests';
import { getMatcherFormName } from './MatcherGetFormName';

function logMatcherGAEvents(
  referenceId: string,
  interests: string[],
  localFormTracker: FormTracker = formTracker
) {
  if (interests.includes(TaxServiceOptions.personal_taxes.value)) {
    localFormTracker.trackModule({
      type: 'form_option',
      category: 'tax_interest',
      label: 'individual_family',
      value: 0
    });
  }
  if (interests.includes(TaxServiceOptions.small_business.value)) {
    localFormTracker.trackModule({
      type: 'form_option',
      category: 'tax_interest',
      label: 'small_business',
      value: 0
    });
  }

  localFormTracker.trackModule({
    type: 'lead',
    category: 'tax',
    label: 'primary',
    value: 0
  });
  localFormTracker.trackValidSubmission();
  localFormTracker.trackConfirmation({ referenceId });
}

async function handleMatcherReferralResponse(
  referralResponse: ReferralResponse,
  answers: MatcherAnswers,
  email: string | null,
  partnershipUrn: string
) {
  const [firstName, lastName] = getNameParts(answers);
  const postalCode = getAnsweredString(answers.postalCode);

  logMatcherGAEvents(
    referralResponse.request_key,
    mapServicesToInterests(answers)
  );
  await waitForTracking(() =>
    trackFormSubmitted({
      trusted_referral_key: referralResponse.request_key,
      fan: {
        first_name: firstName,
        last_name: lastName,
        email: email ?? '',
        phone_number: getAnsweredString(answers.phone),
        postal_code: postalCode
      },
      form_name: getMatcherFormName()
    })
  );
  navigateToResultsPage(
    referralResponse.request_key,
    partnershipUrn,
    undefined,
    undefined,
    postalCode,
    { showLoadingPage: false, source: 'matcher' }
  );
}

export { handleMatcherReferralResponse };
